import React from "react";
import { Button, ButtonProps } from "@mui/material";

interface TallyButtonProps extends Omit<ButtonProps, "size" | "variant"> {
  size?: "small" | "medium" | "large";
  variant?: "outlined" | "contained" | "text";
  children: React.ReactNode;
}

const TallyButton: React.FC<TallyButtonProps> = ({
  size = "small",
  variant = "outlined",
  sx = {},
  children,
  ...props
}) => {
  return (
    <Button
      size={size}
      variant={variant}
      sx={{
        textTransform: "none",
        borderRadius: "1.5625rem",
        whiteSpace: "nowrap",
        fontWeight: "normal",
        minWidth: "auto",
        maxWidth: "none",
        fontSize: {
          xs: "0.8rem",
          sm: "0.8rem",
          md: "0.9rem",
          lg: "1.1rem",
          xl: "1.1rem",
        },
        padding: {
          xl: "0.125rem 1rem 0.125rem 1rem",
          lg: "0.125rem 1rem 0.125rem 1rem",
          md: "0.125rem 0.875rem 0.125rem 0.875rem",
          sm: "0.125rem 0.75rem 0.125rem 0.75rem",
          xs: "0.125rem 0.625rem 0.125rem 0.625rem",
        },
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
          borderRadius: "1.5625rem",
        },
        // Merge any additional sx props
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default TallyButton;
